(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snzo-air-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__snzAirOfferEngine) return;
  window.__snzAirOfferEngine = true;
  const updateButton = fieldset => {
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    const buttonText = fieldset.closest('form').querySelector('button[type="submit"] span');
    if (selection) fieldset.querySelector('[data-air-quantity]').value = selection.dataset.quantity;
    if (selection && !selection.disabled && buttonText) buttonText.textContent = fieldset.dataset.buttonLabel + ' · ' + selection.dataset.price;
  };
  document.querySelectorAll('[data-air-packs]').forEach(updateButton);
  document.addEventListener('change', event => {
    const fieldset = event.target.closest('[data-air-packs]');
    if (fieldset) updateButton(fieldset);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form');
    const fieldset = form?.querySelector('[data-air-packs]');
    if (!fieldset) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.airPending) return;
    const config = fieldset.dataset;
    const status = fieldset.querySelector('[data-air-status]');
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    if (!selection || selection.disabled) { status.textContent = config.error; return; }
    const id = selection.dataset.variant || new FormData(form).get('id');
    const quantity = Number(selection.dataset.quantity);
    if (!id || !Number.isInteger(quantity) || quantity < 1 || quantity > 3) { status.textContent = config.error; return; }
    const items = [{id: Number(id), quantity}];
    const button = form.querySelector('button[type="submit"]');
    form.dataset.airPending = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    status.textContent = config.busy;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : config.error);
      status.textContent = config.added;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (typeof drawer.open === 'function') drawer.open();
      } else location.assign(config.cartUrl || root + 'cart');
    } catch (error) { status.textContent = error.message || config.error; }
    finally { delete form.dataset.airPending; form.removeAttribute('aria-busy'); if (button) button.disabled = false; }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snzo-cocon-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__snzCoconOfferEngine) return;
  window.__snzCoconOfferEngine = true;
  const updateButton = fieldset => {
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    const buttonText = fieldset.closest('form').querySelector('button[type="submit"] span');
    if (selection && buttonText) buttonText.textContent = fieldset.dataset.buttonLabel + ' · ' + selection.dataset.price;
  };
  document.querySelectorAll('[data-cocon-packs]').forEach(updateButton);
  document.addEventListener('change', event => {
    const fieldset = event.target.closest('[data-cocon-packs]');
    if (fieldset) updateButton(fieldset);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form');
    const fieldset = form?.querySelector('[data-cocon-packs]');
    if (!fieldset) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.coconPending) return;
    const config = fieldset.dataset;
    const status = fieldset.querySelector('[data-cocon-status]');
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    if (!selection || selection.disabled) { status.textContent = config.error; return; }
    const id = selection.dataset.variant || new FormData(form).get('id');
    if (!id) { status.textContent = config.error; return; }
    const button = form.querySelector('button[type="submit"]');
    form.dataset.coconPending = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    status.textContent = config.busy;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(id), quantity: 1}], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : config.error);
      status.textContent = config.added;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (typeof drawer.open === 'function') drawer.open();
      } else location.assign(config.cartUrl || root + 'cart');
    } catch (error) { status.textContent = error.message || config.error; }
    finally { delete form.dataset.coconPending; form.removeAttribute('aria-busy'); if (button) button.disabled = false; }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snzo-halo-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__snzHaloOfferEngine) return;
  window.__snzHaloOfferEngine = true;
  const root = () => window.Shopify?.routes?.root || '/';
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form');
    const fieldset = form?.querySelector('[data-halo-packs]');
    if (!fieldset) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.haloPending) return;
    const config = fieldset.dataset;
    const status = fieldset.querySelector('[data-snz-status]');
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    const baseId = String(new FormData(form).get('id'));
    let id = baseId;
    if (selection && selection.value !== '1') {
      const color = baseId === '63673140609354' ? 'gold' : baseId === '63673140642122' ? 'black' : null;
      if (!color || !selection.dataset[color + 'Id'] || selection.dataset[color + 'Available'] !== 'true') {
        status.textContent = config.error;
        return;
      }
      id = selection.dataset[color + 'Id'];
    }
    if (!selection || selection.disabled) {
      status.textContent = config.error;
      return;
    }
    const button = form.querySelector('button[type="submit"]');
    form.dataset.haloPending = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    status.textContent = config.busy;
    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(id), quantity: 1}], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : config.error);
      status.textContent = config.added;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (typeof drawer.open === 'function') drawer.open();
      } else location.assign(config.cartUrl || root() + 'cart');
    } catch (error) {
      status.textContent = error.message || config.error;
    } finally {
      delete form.dataset.haloPending;
      form.removeAttribute('aria-busy');
      if (button) button.disabled = false;
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snzo-hush-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__snzHushOfferEngine) return;
  window.__snzHushOfferEngine = true;
  const updateButton = fieldset => {
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    const buttonText = fieldset.closest('form').querySelector('button[type="submit"] .main-atc__label');
    if (selection) fieldset.querySelector('[data-hush-quantity]').value = selection.dataset.quantity;
    if (selection && !selection.disabled && buttonText) buttonText.textContent = fieldset.dataset.buttonLabel + ' · ' + selection.dataset.price;
  };
  document.querySelectorAll('[data-hush-packs]').forEach(updateButton);
  document.addEventListener('change', event => {
    const fieldset = event.target.closest('[data-hush-packs]');
    if (fieldset) updateButton(fieldset);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form');
    const fieldset = form?.querySelector('[data-hush-packs]');
    if (!fieldset) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.hushPending) return;
    const config = fieldset.dataset;
    const status = fieldset.querySelector('[data-hush-status]');
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    if (!selection || selection.disabled) { status.textContent = config.error; return; }
    const id = selection.dataset.variant || new FormData(form).get('id');
    const quantity = Number(selection.dataset.quantity);
    if (!id || !Number.isInteger(quantity) || quantity < 1 || quantity > 3) { status.textContent = config.error; return; }
    const items = [{id: Number(id), quantity}];
    const button = form.querySelector('button[type="submit"]');
    form.dataset.hushPending = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    status.textContent = config.busy;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : config.error);
      status.textContent = config.added;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (typeof drawer.open === 'function') drawer.open();
      } else location.assign(config.cartUrl || root + 'cart');
    } catch (error) { status.textContent = error.message || config.error; }
    finally { delete form.dataset.hushPending; form.removeAttribute('aria-busy'); if (button) button.disabled = false; }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snzo-nest-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__snzNestRoamEngine) return;
  window.__snzNestRoamEngine = true;
  const config = () => document.querySelector('[data-snz-nest-config]')?.dataset || {};
  const update = fieldset => {
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    const addon = fieldset.querySelector('[data-nest-roam]');
    const form = fieldset.closest('form');
    const button = form.querySelector('button[type="submit"]');
    if (!selection) return;
    addon.disabled = selection.disabled || selection.dataset.roamAvailable !== 'true';
    if (addon.disabled) addon.checked = false;
    fieldset.querySelector('[data-nest-roam-unavailable]').hidden = !addon.disabled;
    const quantity = addon.checked ? 1 : Number(selection.dataset.quantity);
    fieldset.querySelector('[data-snz-quantity]').value = quantity;
    const total = Number(addon.checked ? selection.dataset.roamPrice : selection.dataset.price);
    const label = button?.querySelector('.main-atc__label');
    if (label && !selection.disabled) label.textContent = fieldset.dataset.buttonLabel + ' · ' + new Intl.NumberFormat(fieldset.dataset.locale, {style:'currency',currency:fieldset.dataset.currency}).format(total / 100);
    if (button) button.disabled = selection.disabled;
  };
  document.querySelectorAll('[data-snz-nest-packs]').forEach(update);
  document.addEventListener('change', event => {
    const fieldset = event.target.closest('[data-snz-nest-packs]');
    if (fieldset) update(fieldset);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form');
    const fieldset = form?.querySelector('[data-snz-nest-packs]');
    if (!fieldset) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.snzNestPending) return;
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    const addon = fieldset.querySelector('[data-nest-roam]');
    const status = fieldset.querySelector('[data-snz-nest-status]');
    if (!selection || selection.disabled || (addon.checked && addon.disabled)) {status.textContent=config().error;return;}
    const id = Number(addon.checked ? selection.dataset.roamVariant : selection.dataset.variant || fieldset.dataset.baseId);
    const quantity = addon.checked ? 1 : Number(selection.dataset.quantity);
    if (!Number.isSafeInteger(id) || id < 1 || !Number.isInteger(quantity) || quantity < 1 || quantity > 3) {status.textContent=config().error;return;}
    const button = form.querySelector('button[type="submit"]');
    form.dataset.snzNestPending='true';
    form.setAttribute('aria-busy','true');
    if (button) button.disabled=true;
    status.textContent=config().busy;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : config().error);
      status.textContent=config().added;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');drawer.renderContents(data);
        if (typeof drawer.open === 'function') drawer.open();
      } else location.assign(config().cartUrl || root+'cart');
    } catch(error) {status.textContent=error.message || config().error;}
    finally {delete form.dataset.snzNestPending;form.removeAttribute('aria-busy');if(button)button.disabled=selection.disabled;}
  },true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snzo-pillow-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__snzPillowOfferEngine) return;
  window.__snzPillowOfferEngine = true;
  const updateButton = fieldset => {
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    const buttonText = fieldset.closest('form').querySelector('button[type="submit"] span');
    if (selection && !selection.disabled && buttonText) buttonText.textContent = fieldset.dataset.buttonLabel + ' · ' + selection.dataset.price;
  };
  document.querySelectorAll('[data-pillow-packs]').forEach(updateButton);
  document.addEventListener('change', event => {
    const fieldset = event.target.closest('[data-pillow-packs]');
    if (fieldset) updateButton(fieldset);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form');
    const fieldset = form?.querySelector('[data-pillow-packs]');
    if (!fieldset) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.pillowPending) return;
    const config = fieldset.dataset;
    const status = fieldset.querySelector('[data-pillow-status]');
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    if (!selection || selection.disabled) { status.textContent = config.error; return; }
    const id = new FormData(form).get('id');
    const quantity = Number(selection.dataset.quantity);
    const masks = Number(selection.dataset.masks);
    if (!id || !quantity || (masks && !config.maskId)) { status.textContent = config.error; return; }
    const items = [{id: Number(id), quantity}];
    if (masks) items.push({id: Number(config.maskId), quantity: masks});
    const button = form.querySelector('button[type="submit"]');
    form.dataset.pillowPending = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    status.textContent = config.busy;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : config.error);
      status.textContent = config.added;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (typeof drawer.open === 'function') drawer.open();
      } else location.assign(config.cartUrl || root + 'cart');
    } catch (error) { status.textContent = error.message || config.error; }
    finally { delete form.dataset.pillowPending; form.removeAttribute('aria-busy'); if (button) button.disabled = false; }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snzo-pulse-cart-upgrade"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__snzPulseCartUpgrade) return;
  window.__snzPulseCartUpgrade = true;
  let pending = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const excluded = (item, kind) => {
    const handle = item.handle || '';
    const matches = (kind === 'cocon' || kind === 'rise' || kind === 'complete_breeze') ? /breeze|avondritueel/.test(handle) : kind === 'hush' ? /halo|sleep-set|rustmoment/.test(handle) || handle === 'snoozeout-transit-set' : /halo|mute|sleep-set|nest-duo|nest-trio/.test(handle) || handle === 'snoozeout-transit-set';
    return matches || (item.item_components || []).some(component => excluded(component, kind));
  };
  const eligibleItem = (cart, id, kind) => {
    if ((kind === 'hush' || kind === 'complete_breeze') && cart.total_discount !== 0) return null;
    const pulses = cart.items.filter(item => item.product_id === id);
    if (pulses.length !== 1 || pulses[0].quantity !== 1 || cart.items.some(item => excluded(item, kind))) return null;
    if (pulses[0].selling_plan_allocation || Object.keys(pulses[0].properties || {}).length) return null;
    return pulses[0];
  };
  const breezeCount = item => {
    if (item.product_id === 16062094082378) return item.quantity;
    if ((item.item_components || []).length) return item.item_components.reduce((n, child) => n + breezeCount(child), 0);
    return [16062094836042,16081421041994].includes(item.product_id) ? item.quantity : 0;
  };
  const reserveEligible = cart => {
    if (cart.items.reduce((n,item) => n + breezeCount(item),0) !== 1) return false;
    if (cart.items.some(item => breezeCount(item) && (item.selling_plan_allocation || Object.keys(item.properties || {}).length))) return false;
    if (cart.total_discount === 0) return true;
    const allocations = cart.items.flatMap(item => item.line_level_discount_allocations || []);
    return cart.total_discount === 400 && allocations.length > 0 && allocations.every(a => a.discount_application.title === 'Complete Sleep Set winkelmandaanbod: 1 Breeze voor €12,95');
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-upgrade-button]');
    if (!button || pending) return;
    event.preventDefault();
    const card = button.closest('[data-cart-upgrade]');
    const status = card.querySelector('[data-cart-upgrade-status]');
    const config = card.dataset;
    pending = true;
    document.querySelectorAll('[data-cart-upgrade-button]').forEach(control => {control.disabled = true;});
    card.setAttribute('aria-busy','true');
    status.textContent = config.busy;
    try {
      const freshResponse = await fetch(root() + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
      if (!freshResponse.ok) throw new Error(config.error);
      const fresh = await freshResponse.json();
      const reserve = config.upgradeKind === 'breeze_reserve';
      const pulse = reserve ? null : eligibleItem(fresh, Number(config.productId), config.upgradeKind);
      const previousAddon = fresh.items.find(item => item.variant_id === Number(config.addonId));
      const previousQuantity = previousAddon?.quantity || 0;
      if (reserve ? !reserveEligible(fresh) || fresh.total_price !== Number(config.basePrice) || previousQuantity + 1 !== Number(config.addonQuantity) : !pulse || pulse.final_line_price !== Number(config.basePrice)) throw new Error(config.stale);
      const sectionIds = [...new Set(['cart-drawer','cart-icon-bubble',document.querySelector('#main-cart-items')?.dataset.id,document.querySelector('#main-cart-footer')?.dataset.id].filter(Boolean))];
      const updates = config.addonId ? {[config.addonId]:Number(config.addonQuantity || 1)} : {[pulse.key]:0,[config.bundleId]:1};
      const response = await fetch(root() + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates,sections:sectionIds,sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(config.error);
      if (config.addonId) {
        const checkResponse = await fetch(root() + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
        if (!checkResponse.ok) { location.assign(root() + 'cart'); return; }
        const checked = await checkResponse.json();
        const halo = checked.items.find(item => item.variant_id === Number(config.addonId));
        const correct = reserve ? halo && halo.quantity === Number(config.addonQuantity) && checked.total_price - fresh.total_price === Number(config.addonPrice) && checked.items.reduce((n,item) => n + breezeCount(item),0) === 2 : halo && halo.quantity === 1 && halo.final_price === Number(config.addonPrice);
        if (!correct) {
          if (halo && halo.quantity === Number(config.addonQuantity || 1)) {
            const rollback = await fetch(root() + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:{[halo.key]:previousQuantity}})});
            if (!rollback.ok) { location.assign(root() + 'cart'); return; }
          }
          throw new Error(config.stale);
        }
      }
      const drawer = document.querySelector('cart-drawer');
      if (document.querySelector('#main-cart-footer')) {
        location.reload();
      } else if (drawer && result.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
        drawer.renderContents(result);
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open();
        drawer.querySelector('#CartDrawer-Checkout')?.focus();
      } else {
        location.assign(root() + 'cart');
      }
    } catch (error) {
      status.textContent = error.message || config.error;
    } finally {
      pending = false;
      card.removeAttribute('aria-busy');
      document.querySelectorAll('[data-cart-upgrade-button]').forEach(control => {control.disabled = false;});
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snzo-pulse-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__snzPulseOfferEngine) return;
  window.__snzPulseOfferEngine = true;
  const config = () => document.querySelector('[data-snz-config]')?.dataset || {};
  const root = () => window.Shopify?.routes?.root || '/';
  const sectionNames = () => [...new Set(['cart-drawer','cart-icon-bubble', document.querySelector('#main-cart-items')?.dataset.id, document.querySelector('#main-cart-footer')?.dataset.id].filter(Boolean))];
  const post = async (endpoint, body) => {
    const response = await fetch(root() + endpoint, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({...body,sections:sectionNames(),sections_url:location.pathname})});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : config().error);
    return data;
  };
  const show = data => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && data.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
      if (typeof drawer.open === 'function') drawer.open();
    } else location.assign(config().cartUrl || root()+'cart');
  };
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-snz-packs] input[type="radio"]');
    if (!input) return;
    const fieldset = input.closest('[data-snz-packs]');
    fieldset.querySelector('[data-snz-quantity]').value = input.dataset.quantity;
    const variant = fieldset.closest('form').querySelector('[name="id"]');
    if (input.dataset.variant) {
      if (!fieldset.dataset.setActive) fieldset.dataset.baseId = variant.value;
      fieldset.dataset.setActive = 'true';
      variant.value = input.dataset.variant;
    } else if (fieldset.dataset.setActive) {
      variant.value = fieldset.dataset.baseId;
      delete fieldset.dataset.setActive;
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form');
    const fieldset = form?.querySelector('[data-snz-packs]');
    if (!fieldset) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (form.dataset.snzPending) return;
    form.dataset.snzPending='true';
    const button = form.querySelector('button[type="submit"]');
    const status = fieldset.querySelector('[data-snz-status]');
    if (button) button.disabled=true;
    form.setAttribute('aria-busy','true');status.textContent=config().busy;
    try {
      const fields = new FormData(form);
      const selection = fieldset.querySelector('input[type="radio"]:checked');
      const item = {id:Number(selection.dataset.variant || fields.get('id')),quantity:Number(selection.dataset.quantity)};
      const data = await post('cart/add.js',{items:[item]});
      status.textContent=config().added;show(data);
    } catch(error) {status.textContent=error.message || config().error;}
    finally {delete form.dataset.snzPending;form.removeAttribute('aria-busy');if(button)button.disabled=false;}
  },true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snzo-rise-offers"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__snzRiseOfferEngine) return;
  window.__snzRiseOfferEngine = true;
  const updateButton = fieldset => {
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    const buttonText = fieldset.closest('form').querySelector('button[type="submit"] .main-atc__label');
    if (selection) fieldset.querySelector('[data-rise-quantity]').value = selection.dataset.quantity;
    if (selection && !selection.disabled && buttonText) buttonText.textContent = fieldset.dataset.buttonLabel + ' · ' + selection.dataset.price;
  };
  document.querySelectorAll('[data-rise-packs]').forEach(updateButton);
  document.addEventListener('change', event => {
    const fieldset = event.target.closest('[data-rise-packs]');
    if (fieldset) updateButton(fieldset);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form');
    const fieldset = form?.querySelector('[data-rise-packs]');
    if (!fieldset) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.risePending) return;
    const config = fieldset.dataset;
    const status = fieldset.querySelector('[data-rise-status]');
    const selection = fieldset.querySelector('input[type="radio"]:checked');
    if (!selection || selection.disabled) { status.textContent = config.error; return; }
    const id = selection.dataset.variant || new FormData(form).get('id');
    const quantity = Number(selection.dataset.quantity);
    if (!id || !Number.isInteger(quantity) || quantity < 1 || quantity > 3) { status.textContent = config.error; return; }
    const items = [{id: Number(id), quantity}];
    const button = form.querySelector('button[type="submit"]');
    form.dataset.risePending = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    status.textContent = config.busy;
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : config.error);
      status.textContent = config.added;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections?.['cart-drawer'] && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (typeof drawer.open === 'function') drawer.open();
      } else location.assign(config.cartUrl || root + 'cart');
    } catch (error) { status.textContent = error.message || config.error; }
    finally { delete form.dataset.risePending; form.removeAttribute('aria-busy'); if (button) button.disabled = false; }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
